import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ShowListBinary from "./ShowListBinary";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import styles from "./Output.module.css";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import PermMedia from "@mui/icons-material/PermMedia";
import CircularProgress from "@mui/material/CircularProgress";
import { getListVersion } from "network/Firebase";
import {getVnTime} from "utils/utils";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


export default function ListVersions({
  setbinaryUpload,
  binaryUpload,
  setBranchName,
  branchName,
}) {
  const [loading, setLoading] = React.useState(true);
  const [listVersionImage, setListVersionImage] = React.useState([]);
  const [ciDetail, setCiDetail] = React.useState({
    ciName: "",
    boards: [],
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const list = await getListVersion(branchName);

        setListVersionImage(list);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const handleListItemClick = (event, ciInfo) => {
    setCiDetail(ciInfo);
  };

  const renderListVersion = (input) => {
    return (
      <Box className={styles.ContainerListImage}>
        {input.map((item, index) => {
          return (
            <ListItemButton
              key={index}
              onClick={(event) => handleListItemClick(event, item)}
            >
              <ListItemAvatar>
                <Avatar>
                  <PermMedia />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color="primary"
                  >
                    {item.ciName || ""}
                  </Typography>
                }
                secondary={
                  <>
                    <Typography variant="body2" color="text.secondary">
                      🕒 Issued at <strong>{getVnTime(item.buildDate)}</strong>
                    </Typography>
                    <Typography
                      variant="body2"
                      color="success.main"
                      fontWeight="medium"
                    >
                      {item.commitMessage}
                    </Typography>
                    {item.commitDescription && (
                      <Typography
                        variant="body2"
                        fontStyle="italic"
                        color="text.secondary"
                      >
                        {item.commitDescription}
                      </Typography>
                    )}
                  </>
                }
                secondaryTypographyProps={{
                  style: {
                    whiteSpace: "normal",
                    overflow: "visible",
                    textOverflow: "clip",
                  },
                }}
              />
            </ListItemButton>
          );
        })}
      </Box>
    );
  };

  return (
    <Box sx={{ width: "100%" }}>
      {ciDetail.ciName == "" ? (
        <>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <div
              style={{
                position: "absolute",
                left: 50,
                top: 80,
              }}
            >
              <IconButton
                color="secondary"
                aria-label="show ros monit or"
                onClick={() => {
                  setBranchName("");
                }}
                className={styles.button__background}
              >
                <ArrowBackIcon></ArrowBackIcon>
              </IconButton>
            </div>
            <Typography
              sx={{ mt: 0, mb: 2 }}
              variant="h6"
              component="div"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              Danh sách các version
              <br />
              <div
                style={{
                  fontSize: "1rem",
                  color: "gray",
                  marginTop: "0.7rem",
                }}
              >
                {branchName}
              </div>
            </Typography>
            {/* <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          centered
        >
          <Tab label="Flash All" {...a11yProps(0)} wrapped></Tab>
          <Tab label="Flash Only Firmware" {...a11yProps(1)} />
        </Tabs> */}
          </Box>
          <Box
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              p: "0 0 0 1.5rem",
            }}
          >
            <List component="nav" aria-label="main mailbox folders">
              {loading ? (
                <CircularProgress />
              ) : (
                renderListVersion(listVersionImage)
              )}
            </List>
            <Divider />
          </Box>
        </>
      ) : (
        <ShowListBinary
          setbinaryUpload={setbinaryUpload}
          binaryUpload={binaryUpload}
          branchName={branchName}
          ciName={ciDetail.ciName || ""}
          boards={ciDetail.boards}
          setCiDetail={setCiDetail}
          createdAt={ciDetail.buildDate}
        />
      )}
    </Box>
  );
}
